export default __webpack_public_path__ + "static/banner04-d997cd8a1bd160dad7f43cf1962dbb38.png";